export default __webpack_public_path__ + "static/media/Mask Group 32@2x.b7fb12b8.png";